module.exports = __webpack_public_path__ + "img/img-9572be.png";